<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="fm04_hd">
<h1 class="h1" id="fm04_hd"><span aria-label=" page 3. " epub:type="pagebreak" id="page_3" role="doc-pagebreak">Los Angeles Times</span></h1>
<p class="sutxt">International Section, September 6, 1984</p>
<p class="indent">Following a four-month-long custody battle, Heaven, the only survivor of doomed Japan Airlines flight 999, has been officially adopted by the Kogo family of Tokyo. The decision comes after much conflict, arising from over three hundred requests for adoption of the girl, who is considered “lucky” by many throughout Japan due to her miraculous survival. Konishi Kogo, CEO of the Japanese industrial giant Kogo Industries, may have used his clout with government officials to adopt the girl, whose parents are believed to have died in the crash….</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm04.vue?9d8e0d8a